import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type InvoiceRoutes = {
    invoiceList: Route
    createInvoice: Route
    invoiceDetails: Route
}

export const invoiceRoutes: InvoiceRoutes = {
    invoiceList: {
        path: 'dashboard/invoices',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.invoice.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-invoices/page-invoices.component').then(
                (m) => m.PageInvoicesComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    createInvoice: {
        path: 'dashboard/invoices/create',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.invoice.write], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('@baboor/baboor-invoice').then(
                (m) => m.CreateInvoiceComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    invoiceDetails: {
        path: 'dashboard/invoices/details/:invoiceId',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.invoice.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('@baboor/baboor-invoice').then(
                (m) => m.InvoiceDetailsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
